import { Action } from '@ngrx/store';
import { IRole } from '@roles/models/IRole';
import { IUserRole } from '@account-users/user/models/UserRole';

export enum RolesActionTypes {
  LOAD_ROLES = '[Users] Load Roles',
  LOAD_ROLES_SUCCESS = '[Users] Load Roles Success',
  LOAD_ROLES_FAILED = '[Users] Load Roles Failed',
}

export class LoadRoles implements Action {
  readonly type = RolesActionTypes.LOAD_ROLES;
}

export class LoadRolesSuccess implements Action {
  readonly type = RolesActionTypes.LOAD_ROLES_SUCCESS;
  constructor(
    public payload: { rolesPermissions: IRole; roles: IUserRole[] },
  ) {}
}

export class LoadRolesFailed implements Action {
  readonly type = RolesActionTypes.LOAD_ROLES_FAILED;
}

export type RolesActions = LoadRoles | LoadRolesSuccess | LoadRolesFailed;
